import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const AsyncImg = ({ src, alt, canLoad, onLoad, onError, children }) => {
  const [img, setImg] = useState(null);
  const container = useRef(null);
  const canTriggerOnLoad = useRef(true);

  useEffect(() => {
    return function cleanup() {
      canTriggerOnLoad.current = false;
    };
  }, []);

  useEffect(() => {
    if (canLoad) {
      const newImg = new Image();
      newImg.onload = () => {
        if (canTriggerOnLoad.current) setImg(newImg);
      };
      newImg.onerror = onError;
      newImg.alt = alt;
      newImg.src = src;
    }
    return function cleanup() {
      setImg(null);
    };
  }, [canLoad, src]);

  useEffect(() => {
    if (img && container.current) {
      container.current.appendChild(img);
      onLoad();
    }
  }, [img, container]);

  if (!img || !canLoad) return children;

  return <span ref={container} />;
};

AsyncImg.propTypes = {
  children: PropTypes.node,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  canLoad: PropTypes.bool,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
};

AsyncImg.defaultProps = {
  children: undefined,
  onLoad: () => {},
  onError: () => {},
  canLoad: true,
};

export default AsyncImg;
